import axios from 'axios';
import getConfig from 'next/config';

const baseURL = getConfig().serverRuntimeConfig?.lookerQuery?.apiUrl;
const lookerQueryClient = axios.create({ baseURL });

export default lookerQueryClient;
